export default {
	// api请求地址
	// baseUrl: 'https://v5.niuteam.cn/',
	baseUrl: 'https://aoxing.hlnweb.cn',
	
	// 图片域名
	// imgDomain: 'https://v5.niuteam.cn/',
	imgDomain: 'https://aoxing.hlnweb.cn',
	
	// 前端域名
	// webDomain: 'https://v5.niuteam.cn//web',
	webDomain: 'https://aoxing.hlnweb.cn/web',
	
	// 腾讯地图key
	// mpKey: '6ZDBZ-CLSLX-66747-7MVM4-HLK47-XMBXU',
	mpKey: 'IZQBZ-3UHEU-WTCVD-2464U-I5N4V-ZFFU3',
	
	// 客服
	// webSocket: 'wss://v5.niuteam.cn//wss',
	webSocket: 'wss://aoxing.hlnweb.cn/wss',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}